<template>
  <div>
    <v-toolbar dense color="white">
      <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form ref="form">
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row>
          <v-col cols="5">
            <v-text-field
              :value="parseDisasterName"
              label="災害名称"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3" lg="2">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              :value="deliveryClsName"
              label="配信区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-textarea
              :value="parsedDeliveryArea"
              label="配信先エリア"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-textarea
              :value="submitItem.deliveryTitle"
              label="件名"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-textarea
              :value="submitItem.lalertMessage"
              label="本文"
              :placeholder="' '"
              disabled
              readonly
              rows="10"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-text-field
              :value="formatDatetime(submitItem.publishEndDate)"
              label="希望公開終了日時"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-textarea
              :value="submitItem.relatedUrl"
              label="関連するホームページ（URL）"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-textarea
              :value="submitItem.correctCancelReason"
              label="訂正／取消理由"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-row>
      <v-col>
        <template>
          <v-btn
            class="mx-2"
            color="primary"
            v-if="hasEditAuth()"
            @click="onClickDuplicate"
          >
            コピーして編集
          </v-btn>
          <v-btn class="mx-2" color="primary" @click="onClickReturn"
            >戻る</v-btn
          >
        </template>
      </v-col>
    </v-row>
    <confirm-dialog ref="confirmSubmit"></confirm-dialog>
    <v-overlay :value="overlay" opacity="0.5" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import ConfirmDialog from "@/components/ConfirmDialog";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import Disaster from "@/plugins/disaster";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import messageUtils from "@/mixins/message-utils";
import { arrayCount } from "@/js/utils";
import { LalertNotificationScreenMode } from "@/js/value-objects/lalert-notification-screen-mode.js";

Vue.use(Disaster);

const lalertInfoRepository = RepositoryFactory.get("lalertInfo");

export default {
  mixins: [messageUtils],
  components: {
    ConfirmDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    delivery_no: String
  },
  data: () => ({
    overlay: false,
    LalertNotificationScreenMode: "",
    screenId: "",
    screenTitle: "",
    submitItem: {
      deliveryNo: "", // 配信番号
      deliveryNoSub: "", // 配信番号枝番
      disasterNo: "", // 災害番号
      emergCls: EmergencyClass.NL, // 緊急事態区分
      deliveryCls: "NE", // 配信区分
      deliveryTitle: "", // 件名
      lalertMessage: "", // 本文／避難行動指針
      publishEndDate: "", // 希望公開終了日時
      deliveryStatus: "0", // 配信ステータス
      relatedUrl: "", // 関連するホームページ
      correctCancelReason: "", // 訂正/取消理由
      deliveryCa: "LI", // 配信種別
      dests: [], // 配信エリアAPI送信用
      deliveryArea: [] // 配信先エリア
    },
    lalertInfo: {}, // Lアラート情報
    disasters: [
      {
        disaster_no: 0,
        disaster_name: ""
      }
    ], //災害情報
    municipalities: [] // 市町村情報
  }),

  computed: {
    // 災害名称（参照用）
    parseDisasterName() {
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        return disasterItem.disaster_name;
      } else {
        return "";
      }
    },

    // 緊急事態区分（参照用）
    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    // 配信区分表示用
    deliveryClsName() {
      const DELIVERY_CLS_NAMELIST = [
        {
          value: "NE",
          text: "新規広報"
        },
        {
          value: "FU",
          text: "続報"
        },
        {
          value: "CO",
          text: "訂正報"
        },
        {
          value: "CA",
          text: "取消報"
        }
      ];

      return DELIVERY_CLS_NAMELIST.find(
        e => e.value == this.submitItem.deliveryCls
      )?.text;
    },

    parsedDeliveryArea() {
      const municipArray = [];
      this.municipalities.forEach(obj => {
        this.submitItem.deliveryArea.forEach(municip => {
          if (obj.value === municip) {
            municipArray.push(obj.text);
          }
        });
      });
      return municipArray;
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // Set the ID & Screen name
      this.LalertNotificationScreenMode = LalertNotificationScreenMode.factory(
        this.$route.name
      );
      this.screenId = this.LalertNotificationScreenMode.getScreenId();
      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);

      // 一覧画面で編集・続報・訂正・取消ボタン押下時、初期化する
      this.delivery_no = this.$route.params.delivery_no; // 配信番号

      // 一覧画面でパラメータで渡された値を配信番号作成
      const PARAMS = {
        delivery_no: this.delivery_no?.split("-")[0],
        delivery_no_sub: this.delivery_no?.split("-")[1]
      };

      // 災害情報
      await this.$store
        .dispatch(
          "disasterInfo/loadDisasterInfo",
          this.LalertNotificationScreenMode.getScreenId()
        )
        .then(() => {
          this.disasters = this.$store.state.disasterInfo.data.results;
        })
        .catch(e => {
          this.handleError(
            e,
            this.LalertNotificationScreenMode.getScreenId(),
            "lalert-management"
          );
        });

      // 市町村
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // 参照画面で再読み込みする場合、配信番号がないため一覧画面に戻る
      if (!PARAMS.delivery_no) {
        this.$router.push("/lalert");
      }

      // Lアラート（お知らせ）情報
      await lalertInfoRepository
        .list(this.screenId, PARAMS)
        .then(res => {
          this.lalertInfo = res.data.results[0];
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // 各値設定
      this.submitItem.deliveryNo = PARAMS.delivery_no;
      this.submitItem.deliveryNoSub = PARAMS.delivery_no_sub;
      this.submitItem.disasterNo = this.lalertInfo.disaster_no;
      this.submitItem.emergCls = this.lalertInfo.emerg_cls;
      this.submitItem.deliveryCls = this.lalertInfo.delivery_cls;
      this.submitItem.deliveryTitle = this.lalertInfo.delivery_title;
      this.submitItem.lalertMessage = this.lalertInfo.lalert_message;
      this.submitItem.publishEndDate = this.lalertInfo.publish_end_date;
      this.submitItem.relatedUrl = this.lalertInfo.related_url;
      this.submitItem.correctCancelReason = this.lalertInfo.correct_cancel_reason;
      if (arrayCount(this.lalertInfo.dests) > 0) {
        this.lalertInfo.dests.forEach(dest => {
          this.submitItem.deliveryArea.push(dest.municip_code);
        });
      }

      // 災害名称のテキストボックス設定
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
      }
      this.overlay = false;
    },

    // 編集画面の権限があるかチェック
    hasEditAuth() {
      const editScreenId = ScreenId.SF2103;
      const editAuth = this.$screenAuthority.find(
        auth => auth.screen_id === editScreenId
      );
      if (editAuth) {
        const screenCrud = ScreenCrud.factory(editAuth.screen_crud);
        return screenCrud.isOperation();
      } else {
        return false;
      }
    },

    // コピーして編集ボタン押下時処理
    onClickDuplicate() {
      const DELIVERY_NO_CONCAT = `${this.submitItem.deliveryNo}-${this.submitItem.deliveryNoSub}`;
      this.$router.push({
        name: `lalert-notification-duplicate`,
        params: {
          delivery_no: DELIVERY_NO_CONCAT
        }
      });
    },

    // 戻るボタン押下時処理
    onClickReturn() {
      this.$router.push("/lalert");
    },

    // 日付表示形式編集
    formatDatetime(datetime) {
      if (!datetime) {
        return "";
      }
      const formattedDatetime = this.$moment(datetime, "YYYYMMDDHHmmssSSS");
      if (!formattedDatetime.isValid()) {
        return "";
      }
      return formattedDatetime.format("YYYY/MM/DD HH:mm");
    }
  }
};
</script>
